var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    bg-gray-900\n    flex\n    items-center\n    justify-center\n  "})}
var staticRenderFns = []

export { render, staticRenderFns }